export const WORLD_WIDTH = 390;
export const WORLD_HEIGHT = 780;
export const MAX_AI_FISH = 12;
export const PLAYER_SPEED = 205;
export const INITIAL_PLAYER_LEVEL = 1;
export const GROWTH_PER_LEVEL = 3;
export const PLAYER_BASE_RADIUS = 20;
export const PLAYER_RADIUS_STEP = 7;
export const AI_RADIUS_PER_LEVEL = 11;
export const FISH_BASE_SPEED = 43;
export const FISH_SPEED_GROWTH = 0.08;
export const BASE_SPAWN_INTERVAL = 1.45;
export const MIN_SPAWN_INTERVAL = 0.55;
export const DASH_SPEED_MULTIPLIER = 2.5;
export const DASH_COOLDOWN_SEC = 1.5;
export const DASH_DURATION_SEC = 0.3;
export const NEAR_MISS_RADIUS_MULT = 1.5;
export const PARTICLE_COUNT_MIN = 5;
export const PARTICLE_COUNT_MAX = 8;
export const PARTICLE_LIFETIME_SEC = 0.4;
export const SHAKE_FRAMES = 6;
export const BOSS_LEVEL_OFFSET = 4;
export const SEAWEED_COUNT = 8;
export const SEAWEED_BASE_HEIGHT = 120;
export const SEAWEED_SWAY_AMPLITUDE = 14;
export const SEAWEED_SWAY_FREQUENCY = 0.8;
export const BUBBLE_SPAWN_INTERVAL = 0.65;
export const BUBBLE_RISE_SPEED = 28;
export const BUBBLE_LATERAL_DRIFT = 9;
export const BUBBLE_LIFETIME = 6;
export const LIGHT_RAY_COUNT = 5;
export const LIGHT_RAY_PARALLAX_STRENGTH = 0.075;
export const LIGHT_RAY_BASE_ALPHA = 0.045;
export const PREDATOR_GLOW_RADIUS_MULT = 1.75;
export const PREDATOR_GLOW_PULSE_SEC = 1.2;
export const COLORS = {
  deep: '#082f49', navy: '#071d33', coral: '#fb7185', yellow: '#fbbf24',
  white: '#f8fafc', ink: '#102a43', glow: '#ef4444',
} as const;
export const INSTRUCTIONS = 'Drag to swim. Eat smaller fish to grow. Avoid every larger fish.';
export const CONTROL_HINT = 'Mobile: Swipe/Tap • PC: Arrow keys / WASD';
export const CONTROL_HINT_DASH = 'Tap/Space to dash';
